var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-menu",
    {
      ref: "menu",
      staticClass: "color-picker",
      attrs: { up: _vm.up },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "activator" }, slot: "activator" },
        [
          _c("w-input", {
            staticClass: "form-control",
            attrs: {
              type: "text",
              fancy: _vm.fancy,
              label: _vm.label,
              "icon-left": _vm.icon,
              "icon-left-tooltip": _vm.iconTooltip,
              "icon-left-click-handler": _vm.iconClickHandler,
            },
            on: { input: _vm.updateFromInput },
            model: {
              value: _vm.colorValue,
              callback: function ($$v) {
                _vm.colorValue = $$v
              },
              expression: "colorValue",
            },
          }),
          _c(
            "span",
            { staticClass: "input-group-addon color-picker-container" },
            [
              _c("span", {
                staticClass: "current-color",
                style: "background-color: " + _vm.colorValue,
              }),
            ]
          ),
        ],
        1
      ),
      _c("w-transition-slide-height", { attrs: { appear: "" } }, [
        _vm.opened
          ? _c(
              "div",
              { ref: "colorpicker", style: { overflow: "hidden" } },
              [
                _vm.compact
                  ? _c("chrome-picker-compact", {
                      staticClass: "picker",
                      class: { up: _vm.up, fancy: _vm.fancy },
                      attrs: {
                        value: _vm.colors,
                        "preset-colors": _vm.presets,
                      },
                      on: { input: _vm.updateFromPicker },
                    })
                  : _c("chrome-picker", {
                      staticClass: "picker",
                      class: { up: _vm.up, fancy: _vm.fancy },
                      attrs: {
                        value: _vm.colors,
                        "preset-colors": _vm.presets,
                      },
                      on: { input: _vm.updateFromPicker },
                    }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }